const content = {
  level: "A1",
  unit: 1,
  title: "Everyday Objects",
  description: "Common objects you see and use every day.",

  explanation: [
    "This unit introduces basic everyday objects.",
    "These words are used in daily life and simple conversations.",
    "At A1 level, focus on recognizing and remembering meanings.",
    "Try to use these words in short sentences."
  ],

  items: [
    {
      word: "book",
      phonetic: "/bʊk/",
      meaning: "كتاب",

      definition_easy: "something you read",
      definition_medium: "a set of written pages",
      definition_hard: "a written or printed work",

      example_easy: "I read a book.",
      example_medium: "She bought a new book.",

      audio: "/sounds/vocabulary/A1/unit1/book.mp3"
    },
    {
      word: "chair",
      phonetic: "/tʃeər/",
      meaning: "كرسي",

      definition_easy: "something you sit on",
      definition_medium: "a seat with a back",
      definition_hard: "a piece of furniture for sitting",

      example_easy: "I sit on a chair.",
      example_medium: "The chair is next to the table.",

      audio: "/sounds/vocabulary/A1/unit1/chair.mp3"
    },
    {
      word: "table",
      phonetic: "/ˈteɪbəl/",
      meaning: "طاولة",

      definition_easy: "something you put things on",
      definition_medium: "a piece of furniture with a flat top",
      definition_hard: "a structure with a flat surface and legs",

      example_easy: "The book is on the table.",
      example_medium: "Put the book on the table.",

      audio: "/sounds/vocabulary/A1/unit1/table.mp3"
    },
    {
      word: "phone",
      phonetic: "/fəʊn/",
      meaning: "هاتف",

      definition_easy: "something you use to call people",
      definition_medium: "a device for communication",
      definition_hard: "an electronic device for voice communication",

      example_easy: "I use my phone.",
      example_medium: "My phone is new.",

      audio: "/sounds/vocabulary/A1/unit1/phone.mp3"
    },
    {
      word: "bag",
      phonetic: "/bæg/",
      meaning: "حقيبة",

      definition_easy: "something you carry things in",
      definition_medium: "a container made of cloth or leather",
      definition_hard: "a flexible container for carrying items",

      example_easy: "My bag is heavy.",
      example_medium: "The bag is on the chair.",

      audio: "/sounds/vocabulary/A1/unit1/bag.mp3"
    }
  ]
};

export default content;